import * as React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { routeConstants } from "app/routes/route-constants";
import { OpenCaseNumber } from "app/area/startup/components/open-case/open-case";
import styles from "./new-case-banner.scss";
import { insertGoToSearchLink } from "./insert-go-to-search-link";
import { AiChatAssistant } from "app/components/ai-chat-assistant/ai-chat-assistant";
import { RiArrowLeftSLine } from "react-icons/ri";
import { IoCloseOutline } from "react-icons/io5";
import { CaseDraftCountPanel } from "app/area/shared/case-draft-info-panel/case-draft-count-panel";
import { InfoText } from "ui/common/info/info-text";
import { MdOutlineAutoAwesome } from "react-icons/md";

export interface NewCaseBannerProps {
  textHeader: string;
  textDescription: string;
  textBtnRegisterNewCase: string;
  textOpenCaseHeader: string;
  textOpenCaseDescription: string;
  textCaseNo: string;
  textOpenCase: string;
  textCaseDraftSubtitle?: string;
  textCaseDraftLinkCase?: string;
  textCaseDraftLinkCases?: string;
  textAiChatAssistantTooltip?: string;
  aiChatAssistant?: boolean;
}

export const NewCaseBanner = ({
  textHeader,
  textDescription,
  textBtnRegisterNewCase,
  textOpenCaseHeader,
  textOpenCaseDescription,
  textCaseNo,
  textOpenCase,
  textCaseDraftSubtitle,
  textCaseDraftLinkCase,
  textCaseDraftLinkCases,
  textAiChatAssistantTooltip,
  aiChatAssistant = false
}: NewCaseBannerProps) => {

  const [isChatExpanded, setIsChatExpanded] = useState<boolean>(false);
  const expandChat = () => setIsChatExpanded(true);
  const collapseChat = () => setIsChatExpanded(false);

  return (
    <div className={`${styles.newCaseBanner} ${isChatExpanded ? styles.chatExpanded : ""}`}>
      <div className={`row ${styles.newCasePanel}`}>
        <div
          className={`col-md-6 ${styles.newCaseContainer} ${styles.colContainer} ${styles.chatCol}`}
        >
          <div>
            <h1>
              <MdOutlineAutoAwesome className={styles.sparklesIcon} />{" "}{textHeader}
            </h1>
            <div className={styles.description}>{textDescription}
              {aiChatAssistant && <InfoText className={styles.infoText} visible={true} text={textAiChatAssistantTooltip} />}
            </div>
            {aiChatAssistant && (
              <div className={styles.aiChatAssistantContainer}>
                <AiChatAssistant
                  setChatAssistantActive={expandChat}
                  isChatActive={isChatExpanded}
                />
              </div>
            )}
          </div>
          {!aiChatAssistant &&  (
            <div>
              <Link
                to={routeConstants.selectCaseType}
                id="register_case"
                className={`btn btn-call-to-action ${styles.btnRegisterNewCase}`}
              >
                {textBtnRegisterNewCase}
              </Link>
            </div>
          )}
          {isChatExpanded && (
            <button
              type="button"
              onClick={collapseChat}
              className={styles.collapseChat}
            >
              <IoCloseOutline />
            </button>
          )}
        </div>
        <div className={`col-md-6 ${styles.colContainer} ${styles.openCaseCol}`}>
          <div>
            <h2 className={`h1 ${styles.caseNumberTitle}`}>
              {textOpenCaseHeader}
            </h2>
            <div className={`${styles.description} ${isChatExpanded ? styles.aiChatAssistantActive : ""}`}>
              {insertGoToSearchLink(textOpenCaseDescription)}
            </div>
          </div>
          <div>
            {!isChatExpanded && (
              <div className={styles.openCaseNumber}>
                <OpenCaseNumber
                  textCaseNo={textCaseNo}
                  textOpenCase={textOpenCase}
                />
              </div>
            )}

            <CaseDraftCountPanel
              textSubtitle={textCaseDraftSubtitle}
              textCase={textCaseDraftLinkCase}
              textCases={textCaseDraftLinkCases} />

            {aiChatAssistant && (
              <button
                type="button"
                onClick={collapseChat}
                className={`${styles.buttonArrow} ${!isChatExpanded ? styles.aiChatAssistantActive : ""}`}
              >
                <RiArrowLeftSLine />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
